import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from "@angular/router";
import {ConfigPageComponent} from "../../../../../core/shared/mvs-page/config-page.component";
import {WidgetConfigInterface} from "../../../../../core/shared/mvs-page/interface/widget-config-page.interface";
import {NavigationItem} from "../../../../../core/shared/dto/navigation/navigation-item";
import {WidgetData} from "../../../../../core/shared/widget/widget-data";
import {MvsCoreService} from "../../../../../core/shared/service/mvs-core.service";
import {ObjectIdentifierData} from "../../../../../core/shared/basic/object-identifier-data";
import {ObjectIdentifier} from "../../../../../core/shared/basic/object-identifier";
import {WidgetFactory} from "../../../../../core/shared/widget/service/widget.factory";
import {WidgetDataParam} from "../../../../../core/shared/widget/widget-data-param";
import {FilterCriteria} from "../../../../../core/shared/filter/api/filter.criteria";
import {
    WidgetFunctionCallBackCreate,
    WidgetToolbarCreateInterface
} from "../../../../../core/shared/helper/widget-function-call-back-create";
import {PageHeaderConfig} from "../../../../../core/shared/service/page/page-header-config.interface";
import {
    MvsConfigHeaderComponent
} from "../../../../../core/shared/components/mvs-config-header/mvs-config-header.component";

@Component({
    selector: 'mvs-ac-config-page',
    templateUrl: './ac-config.page.html',
    standalone: false
})
export class AcConfigPage extends ConfigPageComponent implements OnInit {

    defaultLabel: string = "Provisionskonfiguration";
    activeNavItem: string;

    acAcquisitionCommissionAssignmentWidget: WidgetData;

    navigationItems: NavigationItem[] = [
        {
            label: 'Provisionsvorlagen',
            action: 'ac.AcTemplateAcquisitionCommission',
            tooltip: 'Provisionsvorlagen',
            icon: 'fa-solid fa-file-lines',
            toggleable: false,
            default: true
        },
        {
            label: 'Stornopuffer-Zuweisung',
            action: 'ac.AcAgentCancellationBufferAssignment',
            tooltip: 'Stornopuffer-Zuweisung',
            icon: 'fa-solid fa-shield-halved',
            toggleable: false,
            default: false
        }
    ];

    override widgets: { [key: string]: WidgetConfigInterface } = {
        templateAcquisitionCommissionWidget: {
            alias: 'ac.template.acquisition.commission.config.widget.new',
            label: 'Provisionsvorlagen',
            entity: 'ac.AcTemplateAcquisitionCommission',
            widgetData: new WidgetData()
        },
        templateAcquisitionCommissionSelectableWidget: {
            alias: 'ac.template.acquisition.commission.selectable.widget.new',
            label: 'Provisionsvorlagen',
            entity: 'ac.AcTemplateAcquisitionCommission',
            widgetData: new WidgetData(),
            postFunction: (widget: WidgetConfigInterface) => {
                widget.widgetData.uiComponent = 'selectable';
                widget.widgetData.setParam(WidgetDataParam.create('showSearch', true));
                widget.widgetData.setParam(WidgetDataParam.create('attributeToDisplay', 'e.name'));
            }
        },
        acquisitionCommissionAssignmentWidget: {
            alias: 'ac.acquisition.commission.assignment.config.widget.new',
            label: 'Provisionszuweisungen',
            entity: 'ac.AcAcquisitionCommissionAssignment',
            widgetData: new WidgetData()
        },
        agentCancellationBufferAssignmentWidget: {
            alias: 'ac.agent.cancellation.buffer.assignment.config.widget.new',
            label: 'Stornopuffer-Zuweisung',
            entity: 'ac.AcAgentCancellationBufferAssignment',
            widgetData: new WidgetData()
        }
    };

    constructor(
        protected route: ActivatedRoute,
        protected coreService: MvsCoreService
    ) {
        super(route, coreService);
    }

    ngOnInit(): void {
        super.ngOnInit();
        this.refreshAcquisitionCommissionAssignmentWidgetAll();
        this.initialized = true;
    }

    override postNavigationSelection() {
        if (this.activeNavigationItem?.action === 'ac.AcTemplateAcquisitionCommission') {
            this.refreshAcquisitionCommissionAssignmentWidgetAll();
        }

        // Exit-cleanup: when leaving the template/assignment nav item,
        // null the child widget so re-entry re-initialises in a clean (unfiltered) state.
        if (this.activeNavigationItem?.action !== 'ac.AcTemplateAcquisitionCommission') {
            if (this.acAcquisitionCommissionAssignmentWidget) {
                this.acAcquisitionCommissionAssignmentWidget = null;
            }
        }
    }

    /**
     * Load all acquisition commission assignments without filter.
     */
    refreshAcquisitionCommissionAssignmentWidgetAll() {
        this.acAcquisitionCommissionAssignmentWidget = WidgetFactory.createWidgetTableEntityQl(
            'ac.acquisition.commission.assignment.config.widget.new',
            'Alle Provisionszuweisungen',
            'ac.AcAcquisitionCommissionAssignment',
            'Keine Daten vorhanden'
        );
    }

    /**
     * Load acquisition commission assignments filtered by selected template.
     */
    refreshAcquisitionCommissionAssignmentWidget(templateId: number) {
        this.acAcquisitionCommissionAssignmentWidget = WidgetFactory.createWidgetTableEntityQl(
            'ac.acquisition.commission.assignment.config.widget.new',
            'Zugewiesene Provisionen',
            'ac.AcAcquisitionCommissionAssignment',
            'Keine Daten vorhanden',
            [FilterCriteria.create('templateAcquisitionCommission', FilterCriteria.cOperatorEqual, templateId)]
        );

        const fields: WidgetToolbarCreateInterface[] = [
            {fieldName: 'templateAcquisitionCommissionDtoId', fieldValue: templateId}
        ];
        this.acAcquisitionCommissionAssignmentWidget.functionCallbacks = WidgetFunctionCallBackCreate.widgetToolbarCreate(fields);
    }

    onTemplateSelect(event: ObjectIdentifierData | ObjectIdentifier) {
        const e = event as ObjectIdentifierData;
        const id = e.data['e.id'];
        this.refreshAcquisitionCommissionAssignmentWidget(id);
    }

    onTemplateDeselect() {
        this.refreshAcquisitionCommissionAssignmentWidgetAll();
    }

isNavComponent(): NavigationItem[] {
        return this.navigationItems;
    }

    getPageHeaderConfig(): PageHeaderConfig {
        return {
            component: MvsConfigHeaderComponent,
            inputs: {
                header: 'Provisionskonfiguration',
                categoryTypeMode: 'ticket',
                icon: 'fa-light fa-cards-blank'
            }
        };
    }
}
